import { Mutations } from '@/util/settings/enums';
const mutations = {
    [Mutations.SET_CONTENT](state, data) {
        state.content = data.content;
        state.language = data.language;
        state.isFetched = true;
    }
};
export default mutations;
